/* Millimili 3.0 — ana sayfa davranışları. Sahibi: home ajanı.
   Birden çok bölüm bu dosyayı ekler; tarayıcı her <script> etiketini ayrı çalıştırdığı için
   her şey tek sefer tanımlanır (custom element + window bayrağı). Tema düzenleyicisinde bölüm
   yeniden yüklenince custom element'ler connectedCallback ile kendini yeniden kurar.

   1. Kahraman + transparan header (sayfanın ilk bölümü [data-mm3-hero]):
      Bugünkü mm3 header'ı (snippets/mm3-nav.liquid, header ajanı) kahramanın üstüne kendisi biner ve
      kaydırınca kendisi beyaza döner; bu blok o durumda yalnız ölçüm yapar (--mm3-header-h) ve body'de
      "mm3-hero-in-view" sınıfını tutar. Wonder'ın kendi header'ı (layout 4/5/6, data-transparent) kullanılırsa
      yedek yol devreye girer: kahraman header'ın altındayken "wt-header--transparent" sınıfı verilir,
      çıkınca kaldırılır (Wonder page-header-image-banner.js davranışının aynısı).
   2. <mm3-rail>  : New in şeridi — oklar, ilerleme çizgisi.
   3. <mm3-reels> : Bridal video şeridi — döngüsel, ortadaki büyük; videolar yalnız görünürken yüklenir/oynar. */
(() => {
  if (window.__mm3HomeLoaded) return;
  window.__mm3HomeLoaded = true;

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  /* ---------- 1. Kahraman + header ---------- */
  const heroSetup = () => {
    const hero = document.querySelector('[data-mm3-hero]');
    const headerSection = document.querySelector('header.page-header');
    if (!hero || !headerSection) return;
    const header = headerSection.querySelector('.wt-header[data-transparent]');
    const root = document.documentElement;

    const measure = () => {
      const h = headerSection.offsetHeight;
      if (h > 0) root.style.setProperty('--mm3-header-h', `${h}px`);
      return h;
    };
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(headerSection);
    window.addEventListener('load', measure, { once: true });

    let io;
    const observe = () => {
      if (io) io.disconnect();
      const h = measure() || 76;
      io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const inView = e.isIntersecting;
          document.body.classList.toggle('mm3-hero-in-view', inView);
          if (header) header.classList.toggle('wt-header--transparent', inView);
        });
      }, { rootMargin: `-${h}px 0px 0px 0px`, threshold: 0 });
      io.observe(hero);
    };
    observe();
    window.addEventListener('resize', () => { clearTimeout(observe.t); observe.t = setTimeout(observe, 200); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heroSetup);
  else heroSetup();
  document.addEventListener('shopify:section:load', heroSetup);

  /* ---------- 2. New in şeridi ---------- */
  if (!customElements.get('mm3-rail')) {
    class Mm3Rail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        if (!this.track) return;
        this.list = this.track.firstElementChild;
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');
        this.thumb = this.querySelector('[data-rail-thumb]');
        this.update = this.update.bind(this);
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.track);
        }
        this.update();
      }
      disconnectedCallback() { this.ro?.disconnect(); }
      step() {
        const item = [...this.list.children].find((el) => el.offsetWidth > 0);
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const w = item.offsetWidth + gap;
        return Math.max(1, Math.floor((this.track.clientWidth - 40) / w)) * w;
      }
      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = Math.max(0, scrollWidth - clientWidth);
        if (this.prev) this.prev.disabled = scrollLeft <= 1;
        if (this.next) this.next.disabled = scrollLeft >= max - 1;
        if (this.thumb && scrollWidth > 0) {
          /* home-25: dolu kısım = görünen oran, ama tasarımdaki genişliğin altına inmez (--mm3-thumb-min: 38 / mobil 22);
             konum kalan boşlukta kaydırma oranıyla ilerler, sonda çizginin ucuna oturur */
          const min = parseFloat(getComputedStyle(this).getPropertyValue('--mm3-thumb-min')) || 0;
          const w = Math.min(100, Math.max(min, (clientWidth / scrollWidth) * 100));
          this.thumb.style.width = `${w}%`;
          this.thumb.style.left = `${max > 0 ? (scrollLeft / max) * (100 - w) : 0}%`;
        }
      }
    }
    customElements.define('mm3-rail', Mm3Rail);
  }

  /* ---------- 3. Bridal video şeridi ---------- */
  if (!customElements.get('mm3-reels')) {
    class Mm3Reels extends HTMLElement {
      connectedCallback() {
        this.reels = [...this.querySelectorAll('[data-reel]')];
        this.infos = [...this.querySelectorAll('[data-reel-info]')];
        this.n = this.reels.length;
        if (!this.n) return;
        this.cur = Math.min(this.n - 1, Math.max(0, parseInt(this.dataset.start, 10) || 0));
        this.countEl = this.querySelector('[data-reels-current]');
        this.stage = this.querySelector('[data-reels-stage]');
        this.inView = false;

        this.querySelector('[data-reels-prev]')?.addEventListener('click', () => this.go(this.cur - 1));
        this.querySelector('[data-reels-next]')?.addEventListener('click', () => this.go(this.cur + 1));

        this.reels.forEach((reel, i) => {
          reel.addEventListener('click', (e) => {
            if (this.swiped) return;
            if (e.target.closest('[data-reel-sound]')) return;
            if (i !== this.cur) this.go(i);
            else this.togglePlay(reel);
          });
          reel.querySelector('[data-reel-sound]')?.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleSound(reel);
          });
        });

        this.stage.addEventListener('pointerdown', (e) => { this.sx = e.clientX; this.sy = e.clientY; });
        this.stage.addEventListener('pointerup', (e) => {
          if (this.sx == null) return;
          const dx = e.clientX - this.sx;
          const dy = e.clientY - this.sy;
          this.sx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.swiped = true;
            this.go(this.cur + (dx < 0 ? 1 : -1));
            setTimeout(() => { this.swiped = false; }, 50);
          }
        });

        this.mq = window.matchMedia('(max-width: 767px)');
        this.onMq = () => this.syncVideos();
        this.mq.addEventListener?.('change', this.onMq);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => { this.inView = e.isIntersecting; this.syncVideos(); });
          }, { rootMargin: '200px 0px' });
          this.io.observe(this);
        } else {
          this.inView = true;
        }
        this.render();
      }
      disconnectedCallback() {
        this.io?.disconnect();
        this.mq?.removeEventListener?.('change', this.onMq);
      }
      offset(i) {
        const n = this.n;
        let d = (((i - this.cur) % n) + n) % n;
        if (d > Math.floor((n - 1) / 2)) d -= n;
        return d;
      }
      range() { return isMobile() ? 1 : 2; }
      go(i) {
        this.cur = ((i % this.n) + this.n) % this.n;
        this.reels.forEach((r) => this.setSound(r, false));
        this.render();
      }
      render() {
        this.reels.forEach((reel, i) => {
          const d = this.offset(i);
          reel.style.setProperty('--d', d);
          reel.style.setProperty('--sd', Math.sign(d));
          reel.dataset.abs = Math.abs(d);
          reel.classList.toggle('is-active', d === 0);
          if (d === 0) reel.removeAttribute('aria-hidden');
          else reel.setAttribute('aria-hidden', 'true');
          const btn = reel.querySelector('[data-reel-sound]');
          if (btn) btn.tabIndex = d === 0 ? 0 : -1;
        });
        this.infos.forEach((el, i) => el.classList.toggle('is-active', i === this.cur));
        if (this.countEl) this.countEl.textContent = String(this.cur + 1);
        this.syncVideos();
      }
      syncVideos() {
        const range = this.range();
        this.reels.forEach((reel, i) => {
          const v = reel.querySelector('video');
          if (!v) return;
          const ad = Math.abs(this.offset(i));
          if (!this.inView || ad > range) { if (!v.paused) v.pause(); return; }
          const want = ad === 0 ? (v.dataset.srcHi || v.dataset.srcLo) : (v.dataset.srcLo || v.dataset.srcHi);
          if (want && v.dataset.cur !== want) {
            const t = v.dataset.cur ? v.currentTime : 0;
            v.dataset.cur = want;
            v.src = want;
            if (t) v.addEventListener('loadedmetadata', () => { try { v.currentTime = t; } catch (e) { /* yok say */ } }, { once: true });
          }
          if (reducedMotion() && !reel.dataset.userPlay) return;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        });
      }
      togglePlay(reel) {
        const v = reel.querySelector('video');
        if (!v) return;
        if (v.paused) { reel.dataset.userPlay = '1'; if (!v.src && v.dataset.srcHi) { v.dataset.cur = v.dataset.srcHi; v.src = v.dataset.srcHi; } v.play().catch(() => {}); }
        else { delete reel.dataset.userPlay; v.pause(); }
      }
      setSound(reel, on) {
        const v = reel.querySelector('video');
        const btn = reel.querySelector('[data-reel-sound]');
        if (v) v.muted = !on;
        reel.classList.toggle('is-sound', on);
        if (btn) {
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
        }
      }
      toggleSound(reel) {
        const on = !reel.classList.contains('is-sound');
        this.setSound(reel, on);
        if (on) {
          const v = reel.querySelector('video');
          if (v && v.paused) { reel.dataset.userPlay = '1'; v.play().catch(() => {}); }
        }
      }
    }
    customElements.define('mm3-reels', Mm3Reels);
    // Tema düzenleyicisi: bir video bloğu seçilince şerit o videoya döner
    document.addEventListener('shopify:block:select', (e) => {
      const reel = e.target.closest && e.target.closest('[data-reel]');
      const host = reel && reel.closest('mm3-reels');
      if (host && typeof host.go === 'function') host.go(parseInt(reel.dataset.index, 10) || 0);
    });
  }
})();
